module.exports = {"RI20":"UA-153437793-1","contest-upload-RI20":"UA-153437793-2","contest-instruction-RI20":"UA-153437793-3","trail-RI20":"UA-153437793-4","resource-RI20":"UA-153437793-5","contest-schoolreport-RI20":"UA-153437793-6","contest-faq-RI20":"UA-153437793-7","registration-RI20":"UA-153437793-8","contest-take-RI20":"UA-153437793-9","contest-report-RI20":"UA-153437793-10","defaultId":"UA-153437793-1","TCHR":"UA-153437793-2","STU":"UA-153437793-3"}


//////////////////
// WEBPACK FOOTER
// ./src/config/GA_Tracking_IDS.json
// module id = 618
// module chunks = 0